import React from "react";
import { CheckCircle } from "react-feather";
import { useFormContext } from "react-hook-form";
import { Modal, ModalBody } from "reactstrap";

const SuccessModal = ({ open, isEditMode, onClose }) => {
  const {watch} = useFormContext()
  const findMatches = watch('find_matches.type') !== 'standard'
  return (
    <Modal isOpen={open} toggle={onClose} centered style={{borderRadius: '20px'}}>
      <ModalBody style={{ display: 'flex', padding: '40px', borderRadius: '20px', flexDirection: 'column', rowGap: '13px', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CheckCircle size={45} color='#08783E' />
        <h3 style={{ textAlign: 'center' }}>{isEditMode ? "Request Updated" : (findMatches ?  "Find Matches...." : "Request Added")}</h3>
        <p style={{ textAlign: 'center', fontWeight: '300' }}>{isEditMode ? "Your brand request is updated successfully" : (findMatches ? "Request added to find the matches as well for this brand, will notify once completed" : "Your brand request is added successfully")}</p>
      </ModalBody>
    </Modal>
  );
};

export default SuccessModal;
